<template>
  <div id="BotEditor">
    <div id="edit_form">
      <div class="full_row">
        <h1>Edit Bot: {{bot_name}}</h1>
      </div>
      <div class="form_item">
        <label for="name">Bot Name:</label>
        <input id=name v-model="bot_name">
      </div>
      <div class="form_item">
        <label for="profile_image">Profile Image:</label>
        <input size="50" v-model="profile_image" placeholder="URL to image (should be square)">
      </div>
      <div class="form_item">
        <label for="related_page">Related Page (optional):</label>
        <input size="50" v-model="related_page" placeholder="URL to related page." type="url">
      </div>
      <div class="form_item">
        <label for="description">Description (optional)</label>
        <textarea v-model="description" rows="5" cols="40"
                  placeholder="Public description for this Chatbot"></textarea>
      </div>
      <div class="form_item ">
        <label>Voice Settings</label>
        <div class="voice_settings">
          <div class="form_item ">
            <label for="language">Language</label>
            <select v-bind="language_code">
              <option disabled value="">Please select one</option>
              <option value="de-DE">German (de-DE)</option>
              <option value="en-US">US English (en-US)</option>
            </select>
          </div>
          <div class="form_item">
            <label for="voice">Voice</label>
            <input v-model="speech_voice" placeholder="Use Voice that matches options in dialog flow" size="50">
          </div>
          <div class="form_item">
            <label for="speech_rate">Rate</label>
            <span class="input_range_and_value">
              {{formatted_number(speech_rate,1)}}
            <input v-model="speech_rate"  type="range" min="0.3" max="4" step="0.1">
            </span>
          </div>
          <div class="form_item">
            <label for="voice">Pitch</label>
            <span class="input_range_and_value">
              <b>{{formatted_number(speech_pitch,1)}}</b>
            <input type="range" min="-20" max="20"   step="0.1" v-model="speech_pitch" width="200px"/>
            </span>
          </div>
        </div>
      </div>
      <div class="form_item">
        <div>
          <label for="private_key">Dialog Flow Private Key for Bot</label>
          <a
            href="https://docs.google.com/document/d/1iH6-YERKSFy7mv9W5bn1_aGGpSDlTWjZh7AlEufKa0A/edit?usp=sharing">Step
            by Step Instructions</a>
        </div>
        <textarea v-model="private_key" rows="5" cols="40"
                  placeholder="Paste the entire contents of the JSON private key file here."></textarea>
      </div>
      <div class="form_item">
        <div>Action:</div>
        <div>
          <button @click="cancelEdit">Cancel</button>
          <button @click="saveBot" class="save_button">Save Bot</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "BotEditor",
        data() {
            return {
                bot_name: '',
                language_code: '',
                related_page: '',
                description: '',
                json_key: {},
                profile_image: '',
                speech_voice: '',
                speech_rate: '',
                speech_pitch: '',
                speech_volumeDB: '',
                private_key: ''
            }
        },
        mounted() {
            this.bot_name = this.$route.params.bot_name || 'Name not found in params';
        },
        computed: {

        },
        methods: {
            saveBot() {
                alert("Save the bot")
            },
            cancelEdit() {
                this.$router.push({path: '/admin'});
            },
            formatted_number(number,toFixed){
                number = number || 0;
                toFixed = toFixed || 2;
                return parseFloat(number).toFixed(parseInt(toFixed));
            }

        }

    }
</script>
<style>
</style>

<style scoped>
  #BotEditor {
    display: block;
    border: 2px dotted lime;
    height: 100%;
    width: 100%;
  }

  #edit_form {
    display: grid;
    grid-template-columns: 60px 1fr;
    grid-template-rows: auto;
    grid-gap: 0.25rem;
  }

  button {
    border-radius: 1em;
    border: 2px solid gainsboro;
    font-size: 1.25rem;
  }

  button:hover {
    border: 2px solid black;
    font-weight: bold;
    color: black;
  }

  .save_button {
    background-color: lightgreen;
    border-radius: 1em;
  }

  .form_item {
    display: grid;
    grid-column-start: 1;
    grid-column-end: 3;
    /*
    background-color: lightskyblue;
     */
    grid-template-columns: 100px 1fr;
  }

  .full_row {
    grid-column-start: 1;
    grid-column-end: 3;
  }

  .voice_settings {
    border: 1px solid gainsboro;
  }
</style>
